import { render, staticRenderFns } from "./ModifyInvoice.vue?vue&type=template&id=4813cf92&scoped=true"
import script from "./ModifyInvoice.vue?vue&type=script&lang=ts"
export * from "./ModifyInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813cf92",
  null
  
)

export default component.exports